import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useLocalStorage } from './useLocalStorage';
import { getOrSetAnonymousUserId } from '../utils/index';
import { TOKEN } from '../constants';
import { loggedOutUser } from '../actions';

export const useAuthentication = () => {
  const [userId, setUserId] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dispatch = useDispatch();

  const { jwt } = useSelector(({ userReducer: { jwt } }) => ({
    jwt,
  }));

  const [value] = useLocalStorage(TOKEN);

  useEffect(() => {
    const token = value || jwt || localStorage.getItem(TOKEN);
    const anonymousId = getOrSetAnonymousUserId();

    if (token) {
      const user = atob(token.split('.')[1]);
      const parsedUser = JSON.parse(user);

      if (parsedUser) {
        const date = new Date(parsedUser.exp * 1000);
        const now = new Date();

        if (date < now) {
          localStorage.removeItem(TOKEN);
          dispatch(loggedOutUser({}));
          setUserId(anonymousId);
          setIsLoggedIn(false);
          return;
        }
      }
      setUserId(parsedUser.id);
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem(TOKEN);
      setUserId(anonymousId);
      setIsLoggedIn(false);
      return;
    }
  }, [value, jwt]);
  return [userId, isLoggedIn];
};
